

// const host = "http://31.97.206.32:9007"

// const host = "http://localhost:9007"

const host = "https://pos.staymaster.co.in"


const BASE_URL = `${host}/api/v1`;
const BASE = `${host}`;
const image_path = `${host}/uploads/`;
const image_path_1 = `${host}/uploads`;
const base_url_2 = `${host}/api`;



//const BASE_URL = "http://31.97.206.32:9005/api/v1";
//const BASE = "http://31.97.206.32:9005";
//const image_path = "http://31.97.206.32:9005/uploads/";
//const image_path_1 = "http://31.97.206.32:9005/uploads";

// const image_path_1 = "http://31.97.206.32:9005/uploads";

// const BASE_URL = "http://31.97.206.32:9005/api/v1";
// const BASE = "http://31.97.206.32:9005";
// const image_path = "http://31.97.206.32:9005/uploads/";
// const image_path_1 = "http://31.97.206.32:9005/uploads";

// const BASE = "http://31.97.206.32:9005/api";

const PRODUCT = "product";


export const ENDPOINTS = {
  BASE: BASE_URL,
  cleanBase: BASE,
  IMG_PATH: image_path,

  BASE_2: base_url_2,
  IMG_PATH_1: image_path_1,
  ROOM_DETAILS: `${BASE_URL}/products`,
  MEDIA_UPLOAD: `${BASE_URL}/upload/image`,

  AMENITIES: `${BASE_URL}/amenities`,
  UPLOADED_IMAGES: `${BASE_URL}/products/images/all`,

  // one for all
  CREATE: `${BASE_URL}/create`,
  GET: `${BASE_URL}/get`,
  UPDATE: `${BASE_URL}/edit`,
  DELETE: `${BASE_URL}/delete`,
  
};
